import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/core/lead-docket/")({
  beforeLoad: () => {
    throw redirect({ to: "/core/lead-docket/kanban", replace: true })
  }
})
